import React from 'react'
import {
  PoolListAccordionContainer,
  PoolListAccordionListItem,
  PoolListAccordionButton,
  PoolListAccordionDetailsList,
} from './styled'
import PoolListCard from '../PoolListCard'

const PoolList: React.FC<{ pools: any; token0: any; token1: any }> = ({ pools = [], token0, token1 }) => {
  const [isOpen, setIsOpen] = React.useState(false)

  if (pools.length === 0) return null
  const pairName = `${token0.token0Symbol === 'WHYPE' ? 'HYPE' : token0.token0Symbol} / 
  ${token1.token1Symbol === 'WHYPE' ? 'HYPE' : token1.token1Symbol}`
  return (
    <PoolListAccordionContainer>
      <PoolListAccordionListItem onClick={() => setIsOpen(!isOpen)}>
        <div
          className="pool-display-none-desktop"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            padding: '0 8px',
          }}
        >
          <h3>Pools ({pools.length})</h3>
          <PoolListAccordionButton onClick={() => setIsOpen(!isOpen)} className="btn" style={{ paddingRight: '0' }}>
            {isOpen ? (
              <svg
                style={{ marginRight: '0' }}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-up"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M6 15l6 -6l6 6" />
              </svg>
            ) : (
              <svg
                style={{ marginRight: '0' }}
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M6 9l6 6l6 -6" />
              </svg>
            )}
          </PoolListAccordionButton>
        </div>
      </PoolListAccordionListItem>
      <PoolListAccordionDetailsList isOpen={isOpen}>
        {pools.map((pool: any) => (
          <PoolListCard key={pool.pairAddress} pool={pool} token0={token0} token1={token1} pairName={pairName} />
        ))}
      </PoolListAccordionDetailsList>
    </PoolListAccordionContainer>
  )
}
export default PoolList
